export default "__VITE_ASSET__2a794b2f__"